import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Mail } from "lucide-react";

export function TestMailDialog({ open, onOpenChange, users, previewUserId, onPreviewUserChange, onSend }) {
  const [testMailTo, setTestMailTo] = useState("");

  const handleSend = async () => {
    const ok = await onSend(testMailTo);
    if (ok) {
      setTestMailTo("");
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white">
        <DialogHeader>
          <DialogTitle>Enviar correo de prueba</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">
              Usar datos de
            </Label>
            <Select value={previewUserId} onValueChange={onPreviewUserChange}>
              <SelectTrigger className="mt-1 focus:ring-orange-500">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {users.map((u) => (<SelectItem key={u.id} value={u.id}>{u.display_name}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">
              Enviar a
            </Label>
            <Input type="email" placeholder="destino@ejemplo.com" value={testMailTo}
              onChange={(e) => setTestMailTo(e.target.value)}
              className="mt-1 focus-visible:ring-orange-500" data-testid="test-mail-to-input" />
          </div>
          <p className="text-xs text-slate-500">
            Si SMTP no está configurado, se generará una vista previa (modo simulado).
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-200">
            Cancelar
          </Button>
          <Button onClick={handleSend} className="bg-orange-600 hover:bg-orange-700 text-white"
            data-testid="send-test-mail-confirm">
            <Mail className="w-4 h-4 mr-2" strokeWidth={1.75} /> Enviar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
